var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 533.1 76.3",
    style: {
      enableBackground: "new 0 0 533.1 76.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.6,25.7v-3.3h-6.1V55h6.1V37.6c0-5.5,4.7-9.8,10.4-9.8l1.5-6.1C60.7,21.7,54.7,23.4,52.6,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.7,22.4v3.8c-3.1-2.6-6.9-4.5-11-4.5c-4.5,0-8.8,1.7-12.1,4.9c-3.2,3.3-5,7.5-5,12.1c0,4.5,1.8,8.8,5,12.1 c3.3,3.2,7.5,4.9,12.1,4.9c4.1,0,7.9-1.9,11-4.5V55h6.1V22.4H94.7z M83.8,49.7c-6,0-11-5-11-11s4.9-11,11-11c6.1,0,11,5,11,11 S89.8,49.7,83.8,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.1,26.3c-3-3-6.9-4.5-11.1-4.5s-8.2,1.8-11.2,4.8c-0.6,0.6-1.1,1.1-1.6,1.8c-0.4-0.6-0.9-1.2-1.5-1.8 c-3-3-7-4.8-11.2-4.8c-3.5,0-6.8,1.6-9.6,3.8v-3.1h-6.1V55h6.1V37.5c0-5.3,4.3-9.7,9.6-9.7c5.3,0,9.6,4.4,9.6,9.7V55h6.1V37.5 c0-5.3,4.3-9.7,9.7-9.7c5.3,0,9.6,4.4,9.6,9.7V55h6.1V37.5C165.7,33.2,164.1,29.3,161.1,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.6,22.4V55h6.1V22.4H174.6z M177.7,9.1c-2.3,0-4.1,1.8-4.1,4c0,2.2,1.8,4.1,4.1,4.1c2.2,0,4-1.9,4-4.1 C181.7,10.8,179.9,9.1,177.7,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.6,40.2c0.1-0.6,0.1-2.3-0.4-5.2c-0.6-3-2.1-5.7-4.1-7.9c-2.9-3.1-6.8-4.9-11.1-4.9 c-4.2,0-8.2,1.8-11,4.9c-2,2.2-3.4,4.9-4.1,7.9c-0.3,1.3-0.4,2.6-0.4,3.8c0,0.5,0,1,0.1,1.5c0.3,3.9,1.8,7.5,4.4,10.2 c2.8,3.2,6.8,5,11,5c3.1-0.1,6.1-0.9,8.6-2.4c1.6-1,3.1-2.2,4.3-3.6l-5.1-3.1c-2.1,2.1-5,3.3-8,3.4c-4.7-0.1-8.8-4.1-9.5-9.5v-0.2 H219.6z M195,34.9c1.5-4.2,5.1-7,9-7c4,0,7.6,2.8,9,7l0.1,0.1H195L195,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.4,26.3c-3-3-7-4.5-11.2-4.5c-3.5,0-6.8,1.6-9.6,3.8v-3.1h-6.1V55h6.1V37.5c0-5.3,4.3-9.7,9.6-9.7 c5.3,0,9.6,4.4,9.6,9.7V55h6.1V37.5C257,33.2,255.3,29.3,252.4,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.1,22.4l-9.9,24.5l-10-24.5h-6.6L272.9,55h6.6l13.2-32.6H286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326,40.2c0.1-0.6,0.2-2.3-0.3-5.2c-0.6-3-2.1-5.7-4.1-7.9c-2.9-3.1-6.8-4.9-11.1-4.9c-4.2,0-8.2,1.8-11,4.9 c-2,2.2-3.4,4.9-4,7.9c-0.3,1.3-0.4,2.6-0.4,3.8c0,0.5,0,1,0.1,1.5c0.3,3.9,1.8,7.5,4.4,10.2c2.9,3.2,6.8,5,11,5 c3.1-0.1,6.1-0.9,8.6-2.4c1.6-1,3.1-2.2,4.3-3.6l-5.1-3.1c-2.1,2.1-5.1,3.3-8,3.4c-4.7-0.1-8.8-4.1-9.5-9.5v-0.2H326z M301.5,34.9 c1.5-4.2,5.1-7,9-7c4,0,7.6,2.8,9,7l0.1,0.1h-18.2L301.5,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.5,25.7v-3.3h-6.1V55h6.1V37.6c0-5.5,4.7-9.8,10.4-9.8l1.5-6.1C346.6,21.7,340.6,23.4,338.5,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.9,22.4v3.8c-3.1-2.6-6.9-4.5-11-4.5c-4.6,0-8.8,1.7-12.1,4.9c-3.2,3.3-5,7.5-5,12.1 c0,4.5,1.8,8.8,5,12.1c3.3,3.2,7.5,4.9,12.1,4.9c4.1,0,7.9-1.9,11-4.5v5.3c0,6-4.9,11.1-11,11.1c-2.6-0.1-5.6-1.3-7.6-2.9 l-4.6,4.1c0.9,0.8,2,1.7,3.1,2.3c2.6,1.6,5.8,2.5,9.2,2.5c4.6,0,8.8-1.8,12-5c3.3-3.2,5.1-7.5,5.1-12.1V22.4H379.9z M369,49.7 c-6.1,0-11-5-11-11s4.9-11,11-11c6,0,11,5,11,11S375,49.7,369,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M394.7,2.7V55h6.1V2.7H394.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.8,40.2c0.1-0.6,0.1-2.3-0.4-5.2c-0.6-3-2.1-5.7-4.1-7.9c-2.9-3.1-6.8-4.9-11.1-4.9 c-4.2,0-8.2,1.8-11,4.9c-2,2.2-3.4,4.9-4.1,7.9c-0.3,1.3-0.4,2.6-0.4,3.8c0,0.5,0,1,0.1,1.5c0.3,3.9,1.8,7.5,4.4,10.2 c2.8,3.2,6.8,5,11,5c3.1-0.1,6.1-0.9,8.6-2.4c1.6-1,3.1-2.2,4.3-3.6l-5.1-3.1c-2.1,2.1-5,3.3-8,3.4c-4.7-0.1-8.8-4.1-9.5-9.5v-0.2 H438.8z M414.2,34.9c1.5-4.2,5.1-7,9-7c4,0,7.6,2.8,9,7l0.1,0.1h-18.2L414.2,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.6,22.4V55h6.1V22.4H446.6z M449.7,9.1c-2.3,0-4.1,1.8-4.1,4c0,2.2,1.8,4.1,4.1,4.1c2.2,0,4-1.9,4-4.1 C453.7,10.8,451.9,9.1,449.7,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.7,45.1c-2,2.8-5.2,4.6-8.8,4.6c-6,0-11-5-11-11s4.9-11,11-11c3.6,0,6.8,1.9,8.8,4.5l4.9-3.6 c-0.5-0.7-1.1-1.4-1.7-2c-3.2-3.2-7.5-4.9-12-4.9c-4.5,0-8.9,1.7-12.1,4.9c-3.2,3.3-5,7.5-5,12.1c0,4.5,1.8,8.8,5,12.1 c3.2,3.2,7.6,4.9,12.1,4.9c4.6,0,8.8-1.7,12-4.9c0.7-0.6,1.2-1.3,1.8-2.1L485.7,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.2,26.3c-3-3-7-4.5-11.2-4.5c-3.5,0-6.8,1.6-9.6,3.8V2.7h-6.1V55h6.1V37.5c0-5.3,4.3-9.7,9.6-9.7 c5.3,0,9.6,4.4,9.6,9.7V55h6.1V37.5C527.7,33.2,526.1,29.3,523.2,26.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,26.6c-3.2-3.2-7.5-4.9-12-4.9c-4.1,0-7.9,1.9-11,4.5v-3.8H5.4v51.2h5.9v-20c0-0.8,0.1-1.5,0.3-2.3l0,0 c0,0,0-0.1,0-0.1c1.1-4.5,5.2-7.9,10-7.9c2.8,0,5.4,1.2,7.3,3.1c1.7,1.7,2.8,4,3,6.6c0,0,0,0,0.1,0c0.9-0.6,1.8-1.3,2.6-2.1 c3.3-3.3,5-7.5,5-12.1C39.6,34.1,37.8,29.8,34.5,26.6z M21.6,40.9c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2 C27.8,38.1,25,40.9,21.6,40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,51.2v0.2h0l0,0C11.5,51.3,11.5,51.2,11.5,51.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4daa936d326103d175228b44f6f342c9.svg";
export { ForwardRef as ReactComponent };